import { ReactComponent as MentionIcon } from 'assets/icons/mention16.svg'
import { IconButton } from 'components/IconButton/IconButton'
import { useProseStateContext } from 'common/ProseInput/ProseStateContext'
import { observer } from 'mobx-react-lite'

export const MentionButton = observer(() => {
  const state = useProseStateContext()

  const isDisabled = !state?.view

  const onPress = () => {
    const view = state?.view
    if (!view) {
      return
    }
    view.dispatch(view.state.tr.insertText(' @'))
    view.focus()
  }

  return <IconButton icon={MentionIcon} isDisabled={isDisabled} onPress={onPress} />
})
